/**
 * Source unique de verite pour « quel role va ou ».
 *
 * Il y avait auparavant deux logiques de redirection independantes -- une dans
 * LoginPage, une dans l'effet de App.tsx -- et elles ne connaissaient pas les
 * memes roles : LoginPage envoyait tout ce qui n'etait pas admin vers
 * /dashboard, donc les coordinateurs et animateurs atterrissaient dans l'espace
 * parent. Tout passe desormais par ce fichier.
 */

/** Roles ayant acces a l'espace de gestion /staff. */
export const STAFF_ROLES = ['admin', 'coordi', 'anim'] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export function isStaffRole(role: string | null | undefined): role is StaffRole {
  return !!role && (STAFF_ROLES as readonly string[]).includes(role);
}

/**
 * Page d'arrivee apres connexion, ou lorsqu'un utilisateur deja connecte
 * atterrit sur `/`.
 *
 * Un role inconnu ou absent tombe sur l'espace parent, qui est le moins
 * privilegie. Les appelants doivent toutefois attendre que le profil soit
 * charge (`profileLoaded`) avant d'appeler cette fonction : sinon un membre du
 * personnel serait envoye vers l'espace parent simplement parce que son role
 * n'est pas encore connu.
 */
export function landingPathForRole(role: string | null | undefined): string {
  switch (role) {
    case 'admin':
      return '/admin';
    case 'coordi':
    case 'anim':
      return '/staff';
    default:
      return '/dashboard';
  }
}

